var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.54297,
    y: 15.9999,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.54297,
    y: 8.99988,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.54297,
    y: 1.99988,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.54297,
    y: 2.99988,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.54297,
    y: 9.99988,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.54297,
    y: 16.9999,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.54297 1.99988)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.08955f3c729c418046307eec5c253961.svg";
export { ForwardRef as ReactComponent };